import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TrendingTicker from "./components/TrendingTicker";
import HotRanking from "./components/HotRanking";
import Categories from "./components/Categories";
import TrackingFeed from "./components/TrackingFeed";
import AboutMethod from "./components/AboutMethod";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import FloatingActions from "./components/FloatingActions";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <TrendingTicker />
        <HotRanking />
        <Categories />
        <TrackingFeed />
        <AboutMethod />
        <Testimonials />
        <Faq />
        <ContactForm />
      </main>
      <Footer />
      <FloatingActions />
    </>
  );
}